export const PAYLATE_POPUP_TEST_ID = 'PAYLATE_POPUP_TEST_ID';

export const PAYLATE_FORM_TEST_ID = 'PAYLATE_FORM_TEST_ID';
